import {NavLink} from 'react-router-dom';

import {
    Box,
    Breadcrumbs,
} from '@mantine/core';
import {Alias} from '../types';
import {config} from "../config";

export const EditPageNavigation = ({component}: { component: Alias }) => {

    const breadcrumbs = [{
        title: 'Account Settings',
        href: '/account-settings',
    },
        {
            title: config.titles.plural,
            href: `/aliases`,
        },
        {title: component.name}].map((item, index) => (
        <Box key={index}> {
            item
                .href ?
                <NavLink to={item.href}>{item.title}</NavLink> : item.title
        }
        </Box>
    ));

    return (
        <Box p={'xs'}><Breadcrumbs separator='→' mt='xs'>{breadcrumbs}</Breadcrumbs></Box>
    );
};
